<script lang="ts">
    import {loaded, roses, roseService} from "../rose";
    import BackButton from "../shared/BackButton.svelte";
    import DetailsRose from "./DetailsRose.svelte";
    import DetailsQueue from "./DetailsQueue.svelte";
    import DetailsError from "./DetailsError.svelte";
    import {gtag} from "../utils";

    export let roseId: string;

    gtag('set', 'page_path', `/detalls/${roseId}`);
    gtag('event', 'page_view');

    let rose = $roses.find(r => r.id === roseId);
    let loading = !$loaded;

    $: {
        if ($loaded && !rose && roseId) {
            update();
        }
    }

    function update() {
        roseService.getRoseNotInJSON(roseId).then(r => rose = r).finally(_ => loading = false);
    }
</script>
<svelte:head>
    <title>Roses UPC - Detalls</title>
</svelte:head>

<BackButton fallbackPath="/galeria"/>

<h1>La teva rosa</h1>
{#if !loading}
    {#if rose?.queuePosition}
        <DetailsQueue bind:rose on:triggerUpdate={update}/>
    {:else if rose}
        <DetailsRose bind:rose/>
    {:else}
        <DetailsError/>
    {/if}
{/if}

<style>

    h1 {
        color: var(--main-color);
        font-size: 2.5em;
        font-weight: 500;
        border-top: 3px solid var(--main-color);
        margin-top: 0;
        padding-top: 15px;
    }


</style>